import { IMockHandler } from '@/mock/mock.handler.interface';
import { okDeleted, okSingle } from '@/mock/mock.response.util';
import { APPLICATION_SETTING_FIXTURES } from '@/mock/application-setting/application-setting.fixtures';

const ID_ROUTE = /\/application-setting\/([^/?]+)$/;

export const applicationSettingHandler: IMockHandler = {
    matches(req: any) {
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }

        const matches = req.url.includes('/application-setting');

        console.log('[ApplicationSettingHandler.matches] Returning:', matches);
        return matches;
    },

    handle(req: any) {
        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);

        // ── GET /application-setting/:id ────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = APPLICATION_SETTING_FIXTURES;
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET /application-setting ────────────────────────────────────────────
        if (method === 'GET' && url.endsWith('/application-setting')) {
            return okSingle(APPLICATION_SETTING_FIXTURES);
        }

        // ── POST /application-setting ───────────────────────────────────────────
        if (method === 'POST' && url.endsWith('/application-setting')) return okSingle({ ...req.body, id: Date.now() });

        // ── PUT /application-setting/:id ────────────────────────────────────────
        if (method === 'PUT' && idMatch) {
            return okSingle({ ...APPLICATION_SETTING_FIXTURES, ...req.body });
        }

        // ── DELETE /application-setting/:id ─────────────────────────────────────
        if (method === 'DELETE' && idMatch) return okDeleted();

        throw new Error(`[LicenseSettingHandler] unhandled: ${method} ${url}`);
    }
};
